<script setup>
import { Doughnut } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement } from "chart.js";
import { computed } from "vue";

ChartJS.register(Title, Tooltip, Legend, ArcElement);

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  options: {
    type: Object,
    default: () => ({}),
  },
  plugins: {
    type: Array,
    default: () => [],
  },
});

// Opciones por defecto
const defaultOptions = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom",
      labels: {
        usePointStyle: true,
      },
    },
  },
  cutout: "60%",
};

// Opciones que el padre puede sobrescribir
const mergedOptions = computed(() => ({
  ...defaultOptions,
  ...props.options,
  plugins: {
    ...defaultOptions.plugins,
    ...props.options?.plugins,
  },
}));
</script>

<template>
  <div class="w-60 mx-auto">
    <Doughnut :data="data" :options="mergedOptions" :plugins="plugins" />
  </div>
</template>
